module.exports = __webpack_public_path__ + "public/Icons/managePaymentGatewayIcon.svg?6ad0c760";